/*
window.animation_en = {};
app.$store.state.animation.animationItems.forEach(item => {
    window.animation_en[item.video] = {
        region: item.region.en || '',
        title: item.title.en || '',
        subtitle: item.subtitle.en || ''
    }
})
* */

export default {
    "lower_lateral__implant_crown_gingival_former": {
        "region": "Lower lateral",
        "title": "Implant+Crown",
        "subtitle": "Gingival former"
    },
    "lower_lateral__implant_crown_titanium_abutment": {
        "region": "Lower lateral",
        "title": "Implant+Crown",
        "subtitle": "Titanium abutment"
    },
    "lower_lateral__implant_crown_zirconium_abutment": {
        "region": "Lower lateral",
        "title": "Implant+Crown",
        "subtitle": "Zirconium abutment"
    },
    "upper_front_implant_crown_extraction": {
        "region": "Upper front",
        "title": "Implant+Crown",
        "subtitle": "with extraction"
    },
    "lower_lateral_implant_crown": {
        "region": "Lower lateral",
        "title": "Implant+Crown",
        "subtitle": ""
    },
    "lower_lateral_implant_crown_extraction": {
        "region": "Lower lateral",
        "title": "Implant+Crown",
        "subtitle": "with extraction"
    },
    "lower_lateral_implant_crowns": {
        "region": "Lower lateral",
        "title": "Implant+Crowns",
        "subtitle": ""
    },
    "lower_lateral_implant_bridge": {
        "region": "Lower lateral",
        "title": "Implant+Bridge",
        "subtitle": ""
    },
    "lower_full_implant_bridge_6_implants": {
        "region": "Lower full",
        "title": "Implant+Bridge",
        "subtitle": ""
    },
    "lower_full_implant_bridge_6_implants_temporary_dentures": {
        "region": "Lower full",
        "title": "Implant+Bridge",
        "subtitle": "with temp.dentures"
    },
    "upper_full_implant_bridge_8_implants": {
        "region": "Upper full",
        "title": "Implant+Bridge",
        "subtitle": ""
    },
    "upper_full_implant_bridge_8_implants_temporary_dentures": {
        "region": "Upper full",
        "title": "Implant Bridge",
        "subtitle": "with temp. dentures"
    },
    "lower_full_implant_bridge_all_on_4": {
        "region": "Lower full",
        "title": "All-on-4™",
        "subtitle": ""
    },
    "lower_jaw_implant_birdge_all_on_6": {
        "region": "Lower jaw",
        "title": "All-on-6™",
        "subtitle": ""
    },
    "upper_full_implant_bridge_all_on_4": {
        "region": "Upper full",
        "title": "All-on-4™",
        "subtitle": ""
    },
    "upper_jaw_implant_bridge_all_on_6": {
        "region": "Upper jaw",
        "title": "All-on-6™",
        "subtitle": ""
    },
    "lower_full_implant_dentures_4_mini_implants": {
        "region": "Lower full",
        "title": "Implant+Dentures",
        "subtitle": "4 mini Implants"
    },
    "lower_full_implant_dentures_6_mini_implants": {
        "region": "Lower full",
        "title": "Implant Dentures",
        "subtitle": "6 mini Implants"
    },
    "upper_full_implant_dentures_4_mini_implants": {
        "region": "Upper full",
        "title": "Implant+Dentures",
        "subtitle": "4 mini Implants"
    },
    "upper_full_implant_dentures_6_mini_implants": {
        "region": "Upper full",
        "title": "Implant+Dentures",
        "subtitle": "6 mini Implants"
    },
    "lower_full_implant_bridge_one_phase": {
        "region": "Lower full",
        "title": "Implant+Bridge",
        "subtitle": "One-phase implants"
    },
    "upper_full_implant_bridge_one_phase": {
        "region": "Upper full",
        "title": "Implant+Bridge",
        "subtitle": "One-phase implants"
    },
    "lower_full__implant_dentures_bar_retained": {
        "region": "Lower full",
        "title": "Implant+Dentures",
        "subtitle": "Bar retained"
    },
    "upper_full_implant_bridge_bar_retained": {
        "region": "Upper full",
        "title": "Implant+Dentures",
        "subtitle": "Bar retained"
    },
    "lower_full__implant_bridge__cement_retained": {
        "region": "Lower full",
        "title": "Implant+Bridge",
        "subtitle": "Cement retained"
    },
    "lower_full__implant_bridge__screw_retained": {
        "region": "Lower full",
        "title": "Implant+Bridge",
        "subtitle": "Screw retained"
    },
    "upper_full_implant_crowns": {
        "region": "Upper full",
        "title": "Implant+Crowns",
        "subtitle": ""
    },
    "lower_full_implant_crowns": {
        "region": "Lower full",
        "title": "Implant+Crowns",
        "subtitle": ""
    },
    "upper_front__crown_lengthening": {
        "region": "Upper front",
        "title": "Lengthening",
        "subtitle": "of the crown"
    },
    "upper_lateral__sinus_lift__frontal_access_v2": {
        "region": "Upper lateral",
        "title": "Sinus lift",
        "subtitle": "Frontal access"
    },
    "upper_lateral__sinus_lift__window_technique": {
        "region": "Upper lateral",
        "title": "Sinus lift",
        "subtitle": "Window technique"
    },
    "upper_lateral__sinus_lift__frontal_access": {
        "region": "Upper lateral",
        "title": "Sinus lift",
        "subtitle": "Frontal access"
    },
    "upper_lateral__sinus_lift__lateral_access": {
        "region": "Upper lateral",
        "title": "Sinus lift",
        "subtitle": "Lateral access"
    },
    "tartar_development_and_gum_recession": {
        "region": "Upper front",
        "title": "Gum recession",
        "subtitle": "Tartar development"
    },
    "lower_front__soft_tissue_surgery": {
        "region": "Lower front",
        "title": "Gum graft",
        "subtitle": ""
    },
    "upper_front__hidden_bone_and_gum_recession": {
        "region": "Upper front",
        "title": "Bone recession",
        "subtitle": "Hidden"
    },
    "lower_lateral_bone_graft_alveloar_ridge_dilation": {
        "region": "Lower lateral",
        "title": "Bone graft",
        "subtitle": "Alveolar ridge dilation"
    },
    "upper_front__bone_graft__ring_method": {
        "region": "Upper front",
        "title": "Bone graft",
        "subtitle": "Ring method"
    },
    "upper_front__bone_graft__using_chin_bone": {
        "region": "Upper front",
        "title": "Bone graft",
        "subtitle": "Using chin bone"
    },
    "upper_front__bone_graft__using_membrane": {
        "region": "Upper front",
        "title": "Bone graft",
        "subtitle": "Using membrane"
    },
    "lower_front__tooth_decay_treatment": {
        "region": "Lower front",
        "title": "Filling",
        "subtitle": ""
    },
    "lower_lateral_inlays": {
        "region": "Lower lateral",
        "title": "Inlays",
        "subtitle": ""
    },
    "lower_lateral__onlay__partial": {
        "region": "Lower lateral",
        "title": "Onlay",
        "subtitle": "Partial"
    },
    "lower_lateral__onlay": {
        "region": "Lower lateral",
        "title": "Onlay",
        "subtitle": ""
    },
    "inlay__onlay__crown": {
        "region": "Lower lateral",
        "title": "Inlay, Onlay, Crown",
        "subtitle": ""
    },
    "lower_lateral_post_zirconium": {
        "region": "Lower lateral",
        "title": "Post",
        "subtitle": "Zirconium"
    },
    "upper_front_post_zirconium": {
        "region": "Upper front",
        "title": "Post",
        "subtitle": "Zirconium"
    },
    "lower_lateral_root_canal_treatment": {
        "region": "Lower front",
        "title": "Root canal",
        "subtitle": ""
    },
    "upper_front_veneers": {
        "region": "Upper front",
        "title": "Veneers",
        "subtitle": ""
    },
    "upper_front__crowns__porcelain_fused_to_metal": {
        "region": "Upper front",
        "title": "Crowns",
        "subtitle": "PFM"
    },
    "upper_front__crowns__zirconium": {
        "region": "Upper front",
        "title": "Crowns",
        "subtitle": "Zirconium"
    },
    "lower_front__bridge__maryland": {
        "region": "Lower front",
        "title": "Bridge",
        "subtitle": "Maryland"
    },
    "lower_lateral__bridge__maryland": {
        "region": "Lower lateral",
        "title": "Bridge",
        "subtitle": "Maryland"
    },
    "upper_front_bridge_extraction": {
        "region": "Upper front",
        "title": "3-unit Bridge",
        "subtitle": "Extraction"
    },
    "lower_lateral_3_unit_bridge": {
        "region": "Lower lateral",
        "title": "3-unit Bridge",
        "subtitle": ""
    },
    "lower_lateral_4_unit_bridge": {
        "region": "Lower lateral",
        "title": "4-unit Bridge",
        "subtitle": ""
    },
    "lower_full_bridge": {
        "region": "Lower full",
        "title": "Bridge",
        "subtitle": ""
    },
    "lower_full_bridge_temporary_bridge": {
        "region": "Lower full",
        "title": "Bridge",
        "subtitle": "with temp.bridge"
    },
    "upper_full_bridge": {
        "region": "Upper full",
        "title": "Bridge",
        "subtitle": ""
    },
    "upper_full_bridge_temporary_bridge": {
        "region": "Upper full",
        "title": "Bridge",
        "subtitle": "with temp.bridge"
    },
    "lower_full_bridge_and_partial_dentures": {
        "region": "Lower full",
        "title": "Bridge+Dentures",
        "subtitle": "with prec.attachment"
    },
    "upper_full_bridge_and_partial_dentures": {
        "region": "Upper full",
        "title": "Bridge+Dentures",
        "subtitle": "with prec.attachment"
    },
    "lower_full_telescopic_crowns_and_dentures": {
        "region": "Lower full",
        "title": "Telescopic Crowns",
        "subtitle": "with dentures"
    },
    "upper_full_telescopic_crowns_and_dentures": {
        "region": "Upper full",
        "title": "Telescopic Crowns",
        "subtitle": "with dentures"
    },
    "lower_full_dentures_removable": {
        "region": "Lower full",
        "title": "Dentures",
        "subtitle": "Removable"
    },
    "upper_and_lower_full_teeth_position_correction_braces": {
        "region": "Upper & lower",
        "title": "Orthodontics",
        "subtitle": "Position correction"
    },
    "upper_and_lower_full__braces": {
        "region": "Upper & Lower Full",
        "title": "Braces",
        "subtitle": ""
    },
    "lower_full__invisible_braces": {
        "region": "Lower full",
        "title": "Invisible braces",
        "subtitle": ""
    },
    "lower_full__tooth_position_correction": {
        "region": "Lower full",
        "title": "Orthodontics",
        "subtitle": "Position correction"
    },
    "lower_lateral__impacted_tooth_exposure": {
        "region": "Lower lateral",
        "title": "Exposure",
        "subtitle": "Impacted tooth"
    },
    "upper_and_lower_full__incognito_lingual_braces": {
        "region": "Upper & lower",
        "title": "Incognito braces",
        "subtitle": "Lingual"
    },
    "upper_andlower_full__over_bite_forsus_appliance": {
        "region": "Upper & lower",
        "title": "Forsus™",
        "subtitle": "Over bite appliance"
    },
    "upper_full__setback__extractions": {
        "region": "Upper full",
        "title": "Setback",
        "subtitle": "Extractions"
    },
    "upper_full__setback__micro_screw": {
        "region": "Upper full",
        "title": "Setback",
        "subtitle": "Micro screw"
    },
    "upper_andlower_full_osteotomy": {
        "region": "Upper & lower",
        "title": "Osteotomy",
        "subtitle": ""
    },
    "upper_full__osteotomy_advancement": {
        "region": "Upper full",
        "title": "Osteotomy",
        "subtitle": "Advancement"
    },
    "lower_full__combined_implant_and_orthodontic_treatment": {
        "region": "Lower full",
        "title": "Orthodontics",
        "subtitle": "with implant"
    },
    "upper_front__crowns__zirconium_vs_porcelain_fused_to_metal": {
        "region": "Upper front",
        "title": "Crowns",
        "subtitle": "Zirconium vs PFM"
    },
    "lower_lateral__implant_crown_titanium_vs_zirconium_abutment_extended": {
        "region": "Lower lateral",
        "title": "Implant+Crown",
        "subtitle": "Titanium vs Zirconium"
    },
    "upper_front_bridge_vs_implant_crown": {
        "region": "Upper front",
        "title": "Bridge vs Implant",
        "subtitle": ""
    },
    "upper_front__bridge_vs_implan_crowns": {
        "region": "Upper front",
        "title": "2 missing teeth",
        "subtitle": "Bridge vs Implants"
    },
    "lower_lateral__implant_crown_titanium_vs_zirconium_abutment": {
        "region": "Lower lateral",
        "title": "Implant+Crown",
        "subtitle": "Titanium vs Zirconium"
    },
    "lower_full_bar_retained_vs_mini_implant_entures": {
        "region": "Lower full",
        "title": "Implantation",
        "subtitle": "Bar retained vs Mini Implant dentures"
    },
    "lower_jaw_one_phase_implants_vs_conventional": {
        "region": "Lower jaw",
        "title": "Implantation",
        "subtitle": "One phase vs Conventional"
    },
    "upper_front_crowns_vs_bridge": {
        "region": "Upper front",
        "title": "Crowns vs Bridge",
        "subtitle": ""
    },
    "upper_front_post_vs_implant_crown": {
        "region": "Upper front",
        "title": "Crown",
        "subtitle": "Post vs Implant"
    },
    "upper_front_veneers_vs_crowns": {
        "region": "Upper front",
        "title": "Veneers vs Crowns",
        "subtitle": ""
    },
    "upper_full_all_on_4_vs_conventional_implants": {
        "region": "Upper full",
        "title": "Implantation",
        "subtitle": "All-on-4™ vs Conventional"
    },
    "upper_full_bridge_vs_implants_vs_partial_dentures": {
        "region": "Upper full",
        "title": "Bridge vs implants vs partial dentures",
        "subtitle": ""
    },
    "upper_implant_crowns_vs_bridge": {
        "region": "Upper",
        "title": "Implant",
        "subtitle": "Crowns vs Bridge"
    },
    "upper_lateral_sinus_lift_implants_vs_one_phase_implants": {
        "region": "Upper lateral",
        "title": "Implantation",
        "subtitle": "Sinus lift vs One phase"
    },
    "lower_full__bone_recession": {
        "region": "Lower full",
        "title": "Bone recession",
        "subtitle": ""
    },
    "lower_lateral__tooth_loss__bone_recession": {
        "region": "Lower lateral",
        "title": "Tooth loss",
        "subtitle": "Bone recession"
    },
    "lower_lateral__tooth_loss__consequences": {
        "region": "Lower lateral",
        "title": "Tooth loss",
        "subtitle": "Consequences"
    },
    "lower_lateral__wisdom_tooth__positions": {
        "region": "Lower lateral",
        "title": "Wisdom tooth",
        "subtitle": "Positions"
    },
    "lower_lateral__wisdom_tooth__swollen_gum": {
        "region": "Lower lateral",
        "title": "Wisdom tooth",
        "subtitle": "Swollen gum"
    },
    "lower_front_implant__distraction_osteogenesis": {
        "region": "Lower front",
        "title": "Distraction osteogenesis",
        "subtitle": ""
    },
    "upper_lateral__implants_zygomatic": {
        "region": "Upper lateral",
        "title": "Zygomatic implants",
        "subtitle": ""
    },
    "lower__front__hygiene__tooth_scaling": {
        "region": "Lower front",
        "title": "Tooth scaling",
        "subtitle": ""
    },
    "lower_front__hygiene__airflow": {
        "region": "Lower front",
        "title": "Airflow",
        "subtitle": ""
    },
    "lower_front__hygiene__ultrasonic": {
        "region": "Lower front",
        "title": "Ultrasonic",
        "subtitle": ""
    },
    "upper_front__hygiene__gel_and_polish": {
        "region": "Upper front",
        "title": "Gel & polish",
        "subtitle": ""
    },
    "lower_front__periodontitis_measurement": {
        "region": "Lower front",
        "title": "Periodontics measurment",
        "subtitle": ""
    },
    "lower_front__hygiene__laser_treatment": {
        "region": "Lower front",
        "title": "Laser treatment",
        "subtitle": ""
    },
    "lower_front__gum_restoration__laser_treatment": {
        "region": "Lower front",
        "title": "Gum restoration",
        "subtitle": "Laser treatment"
    },
    "upper_and_lower_full__hygiene__whitening": {
        "region": "Upper & Lower Full",
        "title": "Whitening",
        "subtitle": ""
    },
    "lower_full__dentures": {
        "region": "Lower full",
        "title": "Dentures",
        "subtitle": ""
    }
}
